/**
 * Service de gestion des documents
 * Centralise tous les appels API liés aux documents et images
 */
import apiService from './api.service';

class DocumentService {
  /**
   * Obtenir l'URL d'un document
   * Note: L'API utilise POST au lieu de GET
   */
  async getDocumentUrl(documentData) {
    const response = await apiService.postForGet('documents/getDocumentUrl', {
      data: documentData
    });
    return response.item || null;
  }

  /**
   * Uploader un document
   */
  async uploadDocument(formData) {
    return await apiService.post('document/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  /**
   * Obtenir la photo de profil
   */
  async getProfilePhoto(userId) {
    return await apiService.get(`document/photo-profil/${userId}`);
  }

  /**
   * Obtenir le logo de la compagnie
   */
  async getCompanyLogo(companyId) {
    return await apiService.get(`document/logo-compagnie/${companyId}`);
  }

  /**
   * Obtenir l'attestation de transport
   */
  async getTransportCertificate(companyId) {
    return await apiService.get(`document/attestation-transport/${companyId}`);
  }

  /**
   * Supprimer un document
   */
  async deleteDocument(documentId) {
    return await apiService.delete(`document/${documentId}`);
  }

  /**
   * Lister les documents d'une entité
   */
  async listDocuments(entityType, entityId) {
    return await apiService.get(`document/${entityType}/${entityId}/list`);
  }
}

export default new DocumentService();
